import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import CenteredState from './CenteredState';

function ErrorState() {
  const { translate } = useTranslation();

  return (
    <CenteredState role="alert" testId="global-search-error" minHeight={0}>
      <Typography variant="body2" color="text.secondary">
        {translate(LangEnum.GLOBAL_SEARCH_ERROR)}
      </Typography>
    </CenteredState>
  );
}

export default ErrorState;
